export default __webpack_public_path__ + "static/media/CloseButton.f3fc87cc.webp";